
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseComponent from '@/author/components/BaseComponent.vue';

@Component
export default class FrameHelper extends BaseComponent {
  @Prop() href!: string;
  @Prop() text!: string;
  created() {
    this.lockForward();
  }

  freeSlide() {
    this.unlock();
  }
}
